var exports = {
  "a": "Box__uA826a",
  "H": "PublishBanners__s-7Hip",
};

module.exports = exports;
